import React, { Suspense } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LoadingBars } from '../LoadingScreen';

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

// Same loader visual as App.tsx's MinimalLoader and the /intro LoadingScreen
// so every "loading" moment in the app looks identical.
const MinimalLoader = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center" style={{ backgroundColor: '#f0e6d2' }}>
    <LoadingBars size="md" />
  </div>
);

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();

  return (
    <Suspense fallback={<MinimalLoader />}>
      <ProtectedRouteContent location={location}>
        {children}
      </ProtectedRouteContent>
    </Suspense>
  );
};

const ProtectedRouteContent: React.FC<{ children?: React.ReactNode; location: ReturnType<typeof useLocation> }> = ({ 
  children, 
  location 
}) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <MinimalLoader />;
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
}; 